import Container from '@/components/ui/Container/Container';

export default function LandmarkProjectListSkeleton() {
  return (
    <section className="animate-pulse bg-[#f8f7f4] py-10 sm:py-12 md:py-14">
      <Container className="mb-8 text-center md:mb-10" size="lg">
        <div className="mx-auto h-10 max-w-md rounded bg-black/10 md:h-12" />
        <div className="mx-auto mt-4 h-4 max-w-xl rounded bg-black/10" />
        <div className="mx-auto mt-2 h-4 max-w-lg rounded bg-black/10" />
      </Container>

      {[...Array(3)].map((_, i) => (
        <div key={i} className="min-h-[60vh] w-full py-6 md:min-h-[70vh] md:py-8">
          <Container size="full">
            <div className="flex flex-col gap-10 lg:flex-row lg:gap-14">
              <div className="lg:w-[38%] lg:shrink-0 space-y-4">
                <div className="h-4 w-32 rounded bg-black/10" />
                <div className="h-8 w-full max-w-sm rounded bg-black/10" />
                <div className="space-y-2 pt-4">
                  <div className="h-3 w-24 rounded bg-black/10" />
                  <div className="h-4 w-full rounded bg-black/10" />
                  <div className="h-4 w-full max-w-md rounded bg-black/10" />
                </div>
              </div>
              <div className="flex-1">
                <div className="aspect-[16/10] w-full rounded-md bg-black/10 md:rounded-lg" />
              </div>
            </div>
          </Container>
        </div>
      ))}
    </section>
  );
}
